import * as XLSX from "xlsx"

import { takeEvery, put, call } from "redux-saga/effects"
import {
  ADD_FILE_GASPROJECT,
  ADD_FILE_GASPROJECT_SINGLE,
  ADD_PACKAGE_INSTALLER,
  STOP_GASPROJECT,
  DELETE_GASPROJECT,
  GET_GASPROJECTS,
  GET_GASPROJECTS_ENG,
  GET_GASPROJECTS_FILTER,
  GET_GASPROJECTS_FULL_FILTER,
  GET_GASPROJECT_FILES,
  GET_GASPROJECT_FREE,
  GET_GASPROJECT_REPORT,
  GET_PACKAGEINSTALLER,
  RESET_PACKAGE,
  RESOLVED_DEFECT,
  SEND_GASPROJECT_TOGAS,
  SUBMIT_GASPROJECT_ADMIN,
  SUBMIT_PACKAGE,
  UPDATE_GASPROJECT,
  UPDATE_GASPROJECT_DETAILS,
  UPDATE_GASPROJECT_DETAILS_NEW,
  UPDATE_GASPROJECT_ENG,
  UPDATE_GASPROJECT_ENG_NEW,
  UPDATE_PROCESS_DEFECT_STAGE,
  UPDATE_PROCESS_DEFECT_STAGE_NEW,
  UPDATE_PROCESS_EXPERT_STAGE,
  UPDATE_PROCESS_EXPERT_STAGE_NEW,
  UPDATE_PROCESS_MAP_STAGE,
  UPDATE_PROCESS_MAP_STAGE_NEW,
  UPSERT_GASPROJECT,
  PREPARE_MAPSTAGE,
  SUBMIT_DESIGN_STAGE,
  PREPARE_FIRSTSUPERVISION_STAGE,
  UPDATE_GASPROJECT_CHECKLIST,
  SUBMIT_FIRSTSUPERVISION_STAGE,
  DELETE_GASPROJECT_FILE,
  PREPARE_DESIGNS_STAGE,
  PAY_BY_EXECUTOR_WALLET,
  GET_GASPROJECT_INFO_PUBLIC,
  GET_GASPROJECTS_FULL_FILTER_EXCEL,
} from "./actionTypes"
import {
  addFileGasProjectFail,
  addFileGasProjectSuccess,
  addPackageInstallerFail,
  addPackageInstallerSuccess,
  stopGasProjectFail,
  stopGasProjectSuccess,
  deleteGasProjectFail,
  getGasProjectReportFail,
  getGasProjectReportSuccess,
  getGasProjectsEngFail,
  getGasProjectsEngSuccess,
  getGasProjectsFail,
  getGasProjectsFilesFail,
  getGasProjectsFilesSuccess,
  getGasProjectsFilterFail,
  getGasProjectsFilterSuccess,
  getGasProjectsFreeFail,
  getGasProjectsFreeSuccess,
  getGasProjectsFullFilterFail,
  getGasProjectsFullFilterSuccess,
  getGasProjectsSuccess,
  getPackageInstallerFail,
  getPackageInstallerSuccess,
  resetPackageFail,
  resetPackageSuccess,
  resolvedDefectFail,
  resolvedDefectSuccess,
  sendGasProjectToGasFail,
  sendGasProjectToGasSuccess,
  submitGasProjectAdminFail,
  submitGasProjectAdminSuccess,
  submitPackageFail,
  submitPackageSuccess,
  updateGasProjectDetailsFail,
  updateGasProjectDetailsNewFail,
  updateGasProjectDetailsNewSuccess,
  updateGasProjectDetailsSuccess,
  updateGasProjectFail,
  updateProcessStageFail,
  updateProcessStageNewFail,
  updateProcessStageNewSuccess,
  updateProcessStageSuccess,
  upsertGasProjectFail,
  upsertGasProjectSuccess,
  updateGasProjectSuccess,
  prepareForMapStageSuccess,
  prepareForMapStageFail,
  submitDesignStageSuccess,
  submitDesignStageFail,
  prepareForFirstSupervisionStageSuccess,
  prepareForFirstSupervisionStageFail,
  updateGasProjectCheckListSuccess,
  updateGasProjectCheckListFail,
  submitFirstSupervisionStageSuccess,
  submitFirstSupervisionStageFail,
  deleteGasProjectFileSuccess,
  deleteGasProjectFileFail,
  getGasProjectInfoPublicSuccess,
  getGasProjectInfoPublicFail,
  prepareForDesignStageSuccess,
  prepareForDesignStageFail,
  payByExecutorWalletSuccess,
  payByExecutorWalletFail,
  deleteGasProjectSuccess,
  getGasProjectsFullFilterExcelSuccess,
  getGasProjectsFullFilterExcelFail
} from "./actions"
import {
  addPackageInstaller,
  stopGasProjectApi,
  deleteGasProject,
  getGasProjectFile,
  getGasProjectFreeApi,
  getGasProjectReport,
  getGasProjects,
  getGasProjectsEng,
  getGasProjectsFilterApi,
  getGasProjectsFullFilterApi,
  getPackageInstaller,
  getUserBalance,
  postFileGasProject,
  resetPackageApi,
  resolvedDefectApi,
  sendGasProjectToGas,
  submitGasProjectByAdmin,
  submitPackage,
  updateGasProject,
  updateGasProjectDetails,
  updateGasProjectEngApi,
  updateProcessDefectStage,
  updateProcessDefectStageNew,
  updateProcessExpertStage,
  updateProcessExpertStageNew,
  updateProcessMapStage,
  updateProcessMapStageNew,
  upsertGasProject,
  prepareForMapStageApi,
  submitDesignStageApi,
  prepareForFirstSupervisionStageApi,
  updateGasProjectCheckListApi,
  submitFirstSupervisionStageApi,
  sendGasProjectToGasCoApi,
  prepareForMapApi,
  deleteGasProjectFileApi,
  prepareForDesignStageApi,
  payByExecutorWalletApi,
  getGasProjectInfoPublicApi,
} from "helpers/backend_helper"
import { getUserBalanceSuccess } from "store/actions"

function* onGetGasProjects({ payload: values }) {
  try {
    
    const response = yield call(getGasProjects,values)
    yield put(getGasProjectsSuccess(response))
  } catch (error) {
    yield put(getGasProjectsFail(error))
  }
}

function* onGetGasProjectsFilter({ payload: values }) {
  try {
    
    const response = yield call(getGasProjectsFilterApi,values)
    
    yield put(getGasProjectsFilterSuccess(response))
  } catch (error) {
    yield put(getGasProjectsFilterFail(error))
  }
}

function* onGetGasProjectsFullFilter({ payload: values }) {
  try {
    const response = yield call(getGasProjectsFullFilterApi,values)
    
    yield put(getGasProjectsFullFilterSuccess(response))
  } catch (error) {
    yield put(getGasProjectsFullFilterFail(error))
  }
}

function* onGetGasProjectsFullFilterExcel({ payload: data }) {
    try {
      const response = yield call(getGasProjectsFullFilterApi, data)
      let i = 1
      const MYdata = response.data.map(x => ({
        ردیف: i++,
        "شماره پرونده":"1001" + x.fileNumber,
        "نام مالک":x.landlordName,
        شهر: x.cityName,
        آدرس: x.address,
        "سایز کنتور": x.inspectionParameterType,
        "نام مجری": x.exeFullName,
        "نام مهندس": x.engCurrentName,
        "تاریخ ارسال": x.solarDateSendToCoGas,
        "نوع کاربری": x.inspectionType,
        "تاریخ تایید توسط مهندس": x.solarDateDeliverGas,
      }))
      const worksheet = XLSX.utils.json_to_sheet(MYdata)
      const workbook = XLSX.utils.book_new()
  
      XLSX.utils.book_append_sheet(workbook, worksheet, "لیست پرونده ها")
      const today = new Date()
      const date =
        today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
      XLSX.writeFile(workbook, `${date}.xlsx`)
  
  
      yield put(getGasProjectsFullFilterExcelSuccess(response))
    } catch (error) {
      yield put(getGasProjectsFullFilterExcelFail(error))
    }
  }


function* onGetGasProjectReport({ payload: values }) {
  try {
    
    const response = yield call(getGasProjectReport,values)
    
    yield put(getGasProjectReportSuccess(response))
  } catch (error) {
    yield put(getGasProjectReportFail(error))
  }
}
function* onGetGasProjectsEng({ payload: queryString }) {
  try {
    const response = yield call(getGasProjectsEng, queryString)
    yield put(getGasProjectsEngSuccess(response))
  } catch (error) {
    yield put(getGasProjectsEngFail(error))
  }
}

function* onUpsertGasProject({ payload: gasProject }) {
  try {
    const response = yield call(upsertGasProject, gasProject)
    // gasProject ={...gasProject,id:response,fileNumber:0}
    yield put(upsertGasProjectSuccess(response))
    const balance = yield call(getUserBalance)
    yield put(getUserBalanceSuccess(balance))
  } catch (error) {
    yield put(upsertGasProjectFail(error))
  }
}

function* onAddFileGasProject({ payload: attachData }) {
  try {
    const response = yield call(postFileGasProject, attachData)
    yield put(addFileGasProjectSuccess(response))
  } catch (error) {
    yield put(addFileGasProjectFail(error))
  }
}

function* onAddFileGasProjectSingle({ payload: attachData }) {
  try {
    const gasProjectId = JSON.parse(attachData.get("gasProjectId"))[0]
    yield call(postFileGasProject, attachData)
    const updateData ={
      id:gasProjectId,
      fileTypeEnum: attachData?.get("fileTypeEnum")
    }
    yield put(addFileGasProjectSuccess({...updateData}))
    const responseFiles = yield call(getGasProjectFile, gasProjectId)
    yield put(getGasProjectsFilesSuccess(responseFiles))
  } catch (error) {
    yield put(addFileGasProjectFail(error))
  }
}

function* onUpdateProcessExpertStage({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateProcessExpertStage, process)
    yield put(updateProcessStageSuccess(response))
    const gasProjects = yield call(getGasProjectsEng, queryString)
    yield put(getGasProjectsEngSuccess(gasProjects))
  } catch (error) {
    console.log("error", error)
    yield put(updateProcessStageFail(error))
  }
}
function* onUpdateProcessExpertStageNew({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateProcessExpertStageNew, process)
    yield put(updateProcessStageNewSuccess(response))
    // const gasProjects = yield call(getGasProjectsFullFilterApi, queryString)
    // yield put(getGasProjectsFullFilterSuccess(gasProjects))

  } catch (error) {
    console.log("error", error)
    yield put(updateProcessStageNewFail(error))
  }
}

function* onUpdateProcessMapStage({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateProcessMapStage, process)
    yield put(updateProcessStageSuccess(response))
    const gasProjects = yield call(getGasProjectsEng, queryString)
    yield put(getGasProjectsEngSuccess(gasProjects))
  } catch (error) {
    console.log("error", error)
    yield put(updateProcessStageFail(error))
  }
}

function* onUpdateProcessMapStageNew({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateProcessMapStageNew, process)
    yield put(updateProcessStageNewSuccess(response))
    window.location.replace(`/projects/GasProjectProcessEng`)

  } catch (error) {
    yield put(updateProcessStageNewFail(error))
    window.location.replace(`/projects/GasProjectProcessEng`)

  }
}

function* onUpdateProcessDefectStage({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateProcessDefectStage, process)
    yield put(updateProcessStageSuccess(response))
    const gasProjects = yield call(getGasProjectsEng, queryString)
    yield put(getGasProjectsEngSuccess(gasProjects))
  } catch (error) {
    console.log("error", error)
    yield put(updateProcessStageFail(error))
  }
}

function* onUpdateProcessDefectStageNew({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateProcessDefectStageNew, process)
    yield put(updateProcessStageNewSuccess(response))
    window.location.replace(`/projects/GasProjectProcessEng`)

  } catch (error) {
    yield put(updateProcessStageNewFail(error))
    window.location.replace(`/projects/GasProjectProcessEng`)

  }
}

function* onGetGasProjectFiles({ payload: gasProjectId }) {
  try {
    if (gasProjectId) {
      const response = yield call(getGasProjectFile, gasProjectId)

      yield put(getGasProjectsFilesSuccess(response))
    }
  } catch (error) {
    yield put(getGasProjectsFilesFail(error))
  }
}


function* onGetGasProjectFree({ payload: fileNumber }) {
  try {
    
    if (fileNumber) {
      const response = yield call(getGasProjectFreeApi, fileNumber)
      yield put(getGasProjectsFreeSuccess(response))
    }
  } catch (error) {
    yield put(getGasProjectsFreeFail(error))
  }
}

function* onGetPackageInstaller({payload: company}) {
  try {
    const response = yield call(getPackageInstaller)
    const result = response.filter(x=>x.companyName===company)
    
    yield put(getPackageInstallerSuccess(result))
  } catch (error) {
    yield put(getPackageInstallerFail(error))
  }
}

function* onSendGasProjectToGas({ payload: fileNumber }) {
  try {
    let response =""
    const fileNumber4= fileNumber.toString().slice(0, 4)
    if(+fileNumber4 >= '2403') {
       response = yield call(sendGasProjectToGasCoApi,fileNumber)
    }
    else {
       response = yield call(sendGasProjectToGas,fileNumber)
    }
    yield put(sendGasProjectToGasSuccess(response))
  } catch (error) {
    yield put(sendGasProjectToGasFail(error))
  }
}

function* onSubmitGasProjectAdmin({ payload: model }) {
  try {
    const response = yield call(submitGasProjectByAdmin,model)
    yield put(submitGasProjectAdminSuccess({gasProjectId:response,forPrepare:model.forPrepare}))
  } catch (error) {
    yield put(submitGasProjectAdminFail(error))
  }
}


function* onAddPackageInstaller({ payload: gasProject }) {
  try {
    const response = yield call(addPackageInstaller,gasProject)
    yield put(addPackageInstallerSuccess(response))
  } catch (error) {
    yield put(addPackageInstallerFail(error))
  }
}
function* onSubmitPackage({ payload: dataSubmit }) {
  try {
    const response = yield call(submitPackage,dataSubmit)
    yield put(submitPackageSuccess(response))
  } catch (error) {
    yield put(submitPackageFail(error))
  }
}
function* onResetPackage({ payload: GpId }) {
  try {
    const response = yield call(resetPackageApi,GpId)
    yield put(resetPackageSuccess(response))
  } catch (error) {
    yield put(resetPackageFail(error))
  }
}

function* onResolvedDefect({ payload: data }) {
  try {
    const response = yield call(resolvedDefectApi,data.gpId)
    yield put(resolvedDefectSuccess({
      id:data.gpId,
      resolved:response.isPrepare,
      solarSolvedDefect:response.solarPrepareDate
    }))
  } catch (error) {
    yield put(resolvedDefectFail(error))
  }
}


function* onPrepareForMapStage({ payload: data }) {
  try {
   const response = yield call(prepareForMapStageApi,data.gpId)
    yield put(prepareForMapStageSuccess(
      {
        id:data.gpId,
        prepare:response.isPrepare,
        solarPrepareForMapStage:response.solarPrepareDate,
        amountDiscrepancy:response.amountDiscrepancy,
      }))
  } catch (error) {
    yield put(prepareForMapStageFail(error))
  }
}

function* onPrepareForFirstSupervisionStage({ payload: data }) {
  try {
    const result = yield call(prepareForFirstSupervisionStageApi,data.gpId)
    yield put(prepareForFirstSupervisionStageSuccess({id:data.gpId,prepare:data.prepare}))
  } catch (error) {
    yield put(prepareForFirstSupervisionStageFail(error))
  }
}

function* onPrepareForDesignStage({ payload: data }) {
  try {
    const response = yield call(prepareForDesignStageApi,data.gpId)
    yield put(prepareForDesignStageSuccess({
      id:data.gpId,
      prepare:data.prepare,
      solarPrepareForDesignStage:response.solarPrepareDate
    }))
  } catch (error) {
    yield put(prepareForDesignStageFail(error))
  }
}

function* onStopGasProject({ payload: data }) {
  try {
    yield call(stopGasProjectApi,data)
    yield put(stopGasProjectSuccess({id:data.gpId,isStop:data.isStop, stopDes:data.stopDes}))
  } catch (error) {
    yield put(stopGasProjectFail(error))
  }
}

function* onUpdateGasProjectDetails({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateGasProjectDetails,process)
    const responseUpdate = {...process,id:response}
    yield put(updateGasProjectDetailsSuccess(responseUpdate))
    const responseProject = yield call(getGasProjectsEng, queryString)
    yield put(getGasProjectsEngSuccess(responseProject))
  } catch (error) {
    yield put(updateGasProjectDetailsFail(error))
  }
}

function* onUpdateGasProjectDetailsNew({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateGasProjectDetails,process)
    const responseUpdate = {...process,id:response}
    yield put(updateGasProjectDetailsNewSuccess(responseUpdate))

  } catch (error) {
    yield put(updateGasProjectDetailsNewFail(error))
  }
}

function* onDeleteGasProject({ payload: id }) {
  try {
    const response = yield call(deleteGasProject, {id})
    if(response === 'success'){
      yield put(deleteGasProjectSuccess(id))
      const balance = yield call(getUserBalance)
      yield put(getUserBalanceSuccess(balance))
    }
  } catch (error) {
    yield put(deleteGasProjectFail(error))
  }
}

function* onUpdateGasProject({ payload: gasProject }) {
  try {
    const response = yield call(updateGasProject,gasProject)
    if(response === 'success'){
      yield put(updateGasProjectSuccess())
      // const body = {searchValue:"", page:1,pageSize:10}
      // const gasProjects = yield call(getGasProjects,body)
      // yield put(getGasProjectsSuccess(gasProjects))
    }
  } catch (error) {
    yield put(updateGasProjectFail(error))
  }
}



function* onUpdateGasProjectEngNew({ payload: {process,queryString} }) {
  try {
    const response = yield call(updateGasProjectEngApi,process)
    if(response === 'success'){
      yield put(getGasProjectsEngSuccess(response))
    }
  } catch (error) {
    yield put(updateGasProjectFail(error))
  }
}


function* onSubmitDesignStage({ payload: {process,queryString} }) {
  try {
    const response = yield call(submitDesignStageApi, process)
    yield put(submitDesignStageSuccess(response))
    window.location.replace(`/projects/GasProjectProcessEng`)

  } catch (error) {
        yield put(submitDesignStageFail(error))
       //window.location.replace(`/projects/GasProjectProcessEng`)
  }
}

function* onSubmitFirstSupervisionStage({ payload: {process,queryString} }) {
  try {
    const response = yield call(submitFirstSupervisionStageApi, process)
    yield put(submitFirstSupervisionStageSuccess(response))

  } catch (error) {
    console.log("error", error)
    yield put(submitFirstSupervisionStageFail(error))
  }
}

function* onUpdateGasProjectCheckList({ payload: checkList }) {
  try {
    const response = yield call(updateGasProjectCheckListApi,checkList)
    const responseUpdate = {checkList,id:response}
    yield put(updateGasProjectCheckListSuccess(responseUpdate))
  } catch (error) {
    yield put(updateGasProjectCheckListFail(error))
  }
}

function* onDeleteGasProjectFiles({ payload: id }) {
  try {
    yield call(deleteGasProjectFileApi, {id})
    yield put(deleteGasProjectFileSuccess({id}))
  } catch (error) {
      console.log('error',error);
    yield put(deleteGasProjectFileFail(error))
  }
}


function* onPayByExecutorWallet({ payload: data }) {
  try {
    const result = yield call(payByExecutorWalletApi,data.gpId)
    yield put(payByExecutorWalletSuccess({id:data.gpId,projectBalance:result}))
  } catch (error) {
    yield put(payByExecutorWalletFail(error))
  }
}

function* onGetGasProjectInfoPublic({ payload: gasProjectId }) {
  try {
    if (gasProjectId) {
      const response = yield call(getGasProjectInfoPublicApi, gasProjectId)
      yield put(getGasProjectInfoPublicSuccess(response))
    }
  } catch (error) {
    yield put(getGasProjectInfoPublicFail(error))
  }
}

function* gasProjectsSaga() {
  yield takeEvery(DELETE_GASPROJECT_FILE, onDeleteGasProjectFiles)
  yield takeEvery(UPSERT_GASPROJECT, onUpsertGasProject)
  yield takeEvery(GET_GASPROJECTS, onGetGasProjects)
  yield takeEvery(GET_GASPROJECTS_FILTER, onGetGasProjectsFilter)
  yield takeEvery(GET_GASPROJECTS_FULL_FILTER, onGetGasProjectsFullFilter)
  yield takeEvery(GET_GASPROJECTS_FULL_FILTER_EXCEL, onGetGasProjectsFullFilterExcel)
  yield takeEvery(GET_GASPROJECT_REPORT, onGetGasProjectReport)
  yield takeEvery(GET_GASPROJECTS_ENG, onGetGasProjectsEng)
  yield takeEvery(ADD_FILE_GASPROJECT, onAddFileGasProject)
  yield takeEvery(ADD_FILE_GASPROJECT_SINGLE, onAddFileGasProjectSingle)

  yield takeEvery(UPDATE_PROCESS_EXPERT_STAGE, onUpdateProcessExpertStage)
  yield takeEvery(UPDATE_PROCESS_MAP_STAGE, onUpdateProcessMapStage)
  yield takeEvery(UPDATE_PROCESS_DEFECT_STAGE, onUpdateProcessDefectStage)

  yield takeEvery(UPDATE_PROCESS_EXPERT_STAGE_NEW, onUpdateProcessExpertStageNew)
  yield takeEvery(UPDATE_PROCESS_MAP_STAGE_NEW, onUpdateProcessMapStageNew)
  yield takeEvery(UPDATE_PROCESS_DEFECT_STAGE_NEW, onUpdateProcessDefectStageNew)


  yield takeEvery(GET_GASPROJECT_FILES, onGetGasProjectFiles)
  yield takeEvery(GET_GASPROJECT_FREE, onGetGasProjectFree)
  yield takeEvery(GET_PACKAGEINSTALLER, onGetPackageInstaller)
  yield takeEvery(SEND_GASPROJECT_TOGAS, onSendGasProjectToGas)
  yield takeEvery(SUBMIT_GASPROJECT_ADMIN, onSubmitGasProjectAdmin)
  yield takeEvery(ADD_PACKAGE_INSTALLER, onAddPackageInstaller)
  yield takeEvery(SUBMIT_PACKAGE, onSubmitPackage)
  yield takeEvery(RESET_PACKAGE, onResetPackage)
  yield takeEvery(UPDATE_GASPROJECT_DETAILS, onUpdateGasProjectDetails)
  yield takeEvery(UPDATE_GASPROJECT_DETAILS_NEW, onUpdateGasProjectDetailsNew)
  yield takeEvery(UPDATE_GASPROJECT, onUpdateGasProject)
  yield takeEvery(UPDATE_GASPROJECT_ENG_NEW, onUpdateGasProjectEngNew)
  yield takeEvery(DELETE_GASPROJECT, onDeleteGasProject)
  yield takeEvery(RESOLVED_DEFECT, onResolvedDefect)
  yield takeEvery(PREPARE_MAPSTAGE, onPrepareForMapStage)
  yield takeEvery(PREPARE_FIRSTSUPERVISION_STAGE, onPrepareForFirstSupervisionStage)
  yield takeEvery(PREPARE_DESIGNS_STAGE, onPrepareForDesignStage)
  yield takeEvery(STOP_GASPROJECT, onStopGasProject)
  yield takeEvery(SUBMIT_DESIGN_STAGE, onSubmitDesignStage)
  yield takeEvery(SUBMIT_FIRSTSUPERVISION_STAGE, onSubmitFirstSupervisionStage)
  yield takeEvery(UPDATE_GASPROJECT_CHECKLIST, onUpdateGasProjectCheckList)
  yield takeEvery(PAY_BY_EXECUTOR_WALLET, onPayByExecutorWallet)
    yield takeEvery(GET_GASPROJECT_INFO_PUBLIC, onGetGasProjectInfoPublic )


}

export default gasProjectsSaga
